import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimengModule } from './primeng.module';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from './services/translation.service';
import { ReactiveFormsModule } from '@angular/forms';
import { CustomInputComponent } from './components/custom-input/custom-input.component';
import { CustomInputGroupComponent } from './components/custom-input-group/custom-input-group.component';
import { CustomSelectComponent } from './components/custom-select/custom-select.component';
import { TermsOfUseComponent } from './components/terms-of-use/terms-of-use.component';
import { AccountCreatedComponent } from './components/account-created/account-created.component';
import { NumberOnlyDirective } from './directive/number-only.directive';
import { NgOtpInputModule } from 'ng-otp-input';
import { CustomAccordionComponent } from './components/custom-accordion/custom-accordion.component';
import { ShopCardComponent } from './components/shop-card/shop-card.component';
import { InstalmentsComponent } from './components/instalments/instalments.component';
import { PrivacyPolicyCommonComponent } from './components/privacy-policy/privacy-policy.component';
import { ExternalScriptsService } from './services/external-scripts.service';
import { CustomTextareaComponent } from './components/custom-textarea/custom-textarea.component';
import { UtcConverterService } from './services/utc-converter.service';
import { UtcToLocalTimePipe } from './pipes/utc-to-local-time.pipe';
import { StickyFooterDirective } from './directive/sticky-footer.directive';
import { HoverTooltipDirective } from './directive/hover-tooltip.directive';
import { ClarityIdentityDirective } from './directive/clarity-identity.directive';

@NgModule({
  declarations: [
    CustomInputComponent,
    CustomInputGroupComponent,
    CustomSelectComponent,
    TermsOfUseComponent,
    AccountCreatedComponent,
    NumberOnlyDirective,
    CustomAccordionComponent,
    ShopCardComponent,
    InstalmentsComponent,
    PrivacyPolicyCommonComponent,
    CustomTextareaComponent,
    UtcToLocalTimePipe,
    StickyFooterDirective,
    HoverTooltipDirective,
    ClarityIdentityDirective,
  ],
  exports: [
    PrimengModule,
    TranslateModule,
    ReactiveFormsModule,
    CustomInputComponent,
    TermsOfUseComponent,
    CustomInputGroupComponent,
    CustomSelectComponent,
    AccountCreatedComponent,
    NumberOnlyDirective,
    NgOtpInputModule,
    CustomAccordionComponent,
    ShopCardComponent,
    InstalmentsComponent,
    PrivacyPolicyCommonComponent,
    CustomTextareaComponent,
    UtcToLocalTimePipe,
    StickyFooterDirective,
    HoverTooltipDirective,
    ClarityIdentityDirective,
  ],
  imports: [CommonModule, PrimengModule, TranslateModule, ReactiveFormsModule, NgOtpInputModule],
  providers: [TranslationService, ExternalScriptsService, UtcConverterService],
})
export class SharedModule {}
